import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteSocioEcoRequest: ['response'],
    deleteSocioEcoSuccess: ['response'],
    deleteSocioEcoFailure: ['error'],
})

export const deleteSocioEcoTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteSocioEcoRequest = state => state.merge({ success: null })

const deleteSocioEcoSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteSocioEcoFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_SOCIO_ECO_REQUEST]: deleteSocioEcoRequest,
    [Types.DELETE_SOCIO_ECO_SUCCESS]: deleteSocioEcoSuccess,
    [Types.DELETE_SOCIO_ECO_FAILURE]: deleteSocioEcoFailure,
})
